import { useEffect } from "react";
import { UseKeyAction } from "./types";

export const useKeyAction: UseKeyAction = ({
  code,
  callback,
  options = {},
}) => {
  const { isDisabled = false, preventDefault = false } = options;

  useEffect(() => {
    if (isDisabled) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.code === code) {
        if (preventDefault) e.preventDefault();
        callback(e);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [code, callback, isDisabled, preventDefault]);
};
